import { createQueryKeys } from '@lukemorales/query-key-factory';

export const funnel = createQueryKeys('funnel', {
  results: (params: { from?: string; to?: string; version?: string; funnelVariant?: string }) => [params],
});
